"use strict";
const FIELD_TYPE = {
    ACCOUNT: 'account',
};
const FIELD_NAME = {
    CUSTOM_METRICS: 'custom_metrics',
};
const ATTRIBUTE_TYPE = {
    DATA_ATTRIBUTE: 'date_attribute',
    STRING_ATTRIBUTE: 'string_attribute',
    NUMBER_ATTRIBUTE: 'number_attribute',
    SIMPLE_DATE_ATTRIBUTE: 'simple_date_attribute',
    DATE: 'date',
    STRING: 'string',
    NUMBER: 'number',
    CURRENCY: 'currency',
    OWNER: 'owner',
};
const FORMAT = {
    DEFAULT_BASE_DATE_FORMAT: 'MMMM Do YYYY',
    DEFAULT_NUMBER_FORMAT: '0,0.[0]a',
};
module.exports = {
    ATTRIBUTE_TYPE,
    FIELD_TYPE,
    FIELD_NAME,
    FORMAT,
};
//# sourceMappingURL=attributesConst.js.map